module.exports = __webpack_public_path__ + "static/media/pc2.4244dfab.png";